import { render, staticRenderFns } from "./createMajorCategory.vue?vue&type=template&id=dfe6c974&scoped=true&"
import script from "./createMajorCategory.vue?vue&type=script&lang=js&"
export * from "./createMajorCategory.vue?vue&type=script&lang=js&"
import style0 from "./createMajorCategory.vue?vue&type=style&index=0&id=dfe6c974&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe6c974",
  null
  
)

export default component.exports